module.exports = __webpack_public_path__ + "static/media/selo4.5f51e83a.png";